import { RECORDING_BOT_JOIN, START_RECORDING, STOP_RECORDING, GET_RECORDING_FILES, DELETE_RECORDING } from '../../constants';
import fetch from '../../fetch';

function joinRecordingBot(token)
{
	return fetch(`${RECORDING_BOT_JOIN}`, {
		method: 'POST',
		body: JSON.stringify({ token })
	});
}

function startRecording(roomId)
{
	return fetch(START_RECORDING, {
		method: 'POST',
		body: JSON.stringify({ roomId })
	});
}

function stopRecording(roomId)
{
	return fetch(STOP_RECORDING, {
		method: 'POST',
		body: JSON.stringify({ roomId })
	});
}

function getRecordingFiles(roomId)
{
	return fetch(GET_RECORDING_FILES(roomId));
}

function deleteRecordingFile(id)
{
	return fetch(DELETE_RECORDING(id), { method: 'DELETE' });
}

export { joinRecordingBot, startRecording, stopRecording, getRecordingFiles, deleteRecordingFile };
